import React from "react";

export default function Avatar({ initials, color, size = 28, title }) {
  const safeInitials = (initials || "").slice(0, 2).toUpperCase();
  const style = {
    width: size,
    height: size,
    borderRadius: "50%",
    backgroundColor: color || "hsl(210,60%,50%)",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    color: "white",
    fontWeight: 700,
    fontSize: size * 0.45,
    lineHeight: 1,
    userSelect: "none",
  };
  return (
    <span style={style} title={title || safeInitials} aria-label="avatar">
      {safeInitials}
    </span>
  );
}
